import React from 'react';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { CircularProgress } from '@material-ui/core';
import { getMeetingInfo } from '../../../redux/dataSlice';

const AxsomeMeetingInfoComponent = (props) => {
  // Alias the injected action creator so it doesn't shadow the module-level
  // import used in the connect() call at the bottom of the file.
  const {
    invalidMeetingCode,
    atCapacity,
    meetingInfo,
    getMeetingInfo: fetchMeetingInfo
  } = props;
  const inviteCode = props.match.params.invitecode;

  React.useEffect(() => {
    if (!meetingInfo) {
      fetchMeetingInfo(inviteCode);
    }
  }, [meetingInfo, inviteCode, fetchMeetingInfo]);

  React.useEffect(() => {
    if (invalidMeetingCode || atCapacity) {
      props.history.push('/');
    }
  }, [invalidMeetingCode, atCapacity]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!meetingInfo) {
    return <CircularProgress />;
  }

  const { speaker, speaker2, venue } = meetingInfo;

  const getDuration = () => {
    if (meetingInfo.startdatetime && meetingInfo.enddatetime) {
      const start = moment(meetingInfo.startdatetime);
      const end = moment(meetingInfo.enddatetime);
      const duration = moment.duration(end.diff(start));
      const hours = Math.floor(duration.asHours());
      const minutes = duration.minutes();
      if (hours > 0 && minutes > 0) {
        return `${hours} hr ${minutes} min`;
      }
      if (hours > 0) {
        return `${hours} hr`;
      }
      return `${minutes} min`;
    }
    return null;
  };

  const isVirtual =
    meetingInfo.meetingtype.trim().toLowerCase() === 'webcast' ||
    (venue && venue.name && venue.name.trim().toLowerCase() === 'virtual');

  return (
    <div className="meeting-info-component">
      <div className="title-text">HELIX</div>
      <hr className="separator" />
      <div>
        <span className="bold">Event Information: </span>
      </div>
      <br />
      <div>
        <span className="bold">Topic: </span>
        {meetingInfo.title}
      </div>
      <br />
      <div>
        <span className="bold">Speaker: </span>
        {speaker.firstname} {speaker.lastname}
        {speaker.title && (
          <>
            <br />
            {speaker.title}
          </>
        )}
        {speaker.orgname && (
          <>
            <br />
            {speaker.orgname}
          </>
        )}
        <br />
        {speaker.city} {speaker.state}
      </div>

      {speaker2 && (
        <>
          <br />
          <div>
            <span className="bold">Speaker 2: </span>
            {speaker2.firstname} {speaker2.lastname}
            {speaker2.title && (
              <>
                <br />
                {speaker2.title}
              </>
            )}
            {speaker2.orgname && (
              <>
                <br />
                {speaker2.orgname}
              </>
            )}
            <br />
            {speaker2.city} {speaker2.state}
          </div>
        </>
      )}
      <br />
      <div>
        <span className="bold">When: </span>
        {moment(meetingInfo.startdatetime).format('LLLL')} -{' '}
        {moment(meetingInfo.enddatetime).format('LT')} {meetingInfo.timezone}
      </div>
      <br />
      {getDuration() && (
        <>
          <div>
            <span className="bold">Duration: </span>
            {getDuration()}
          </div>
          <br />
        </>
      )}
      <div>
        <span className="bold">Location: </span>
        {isVirtual ? (
          'Virtual'
        ) : (
          <>
            {venue.name}
            <br />
            {venue.address1}
            {venue.address2 && (
              <>
                <br />
                {venue.address2}
              </>
            )}
            <br />
            {venue.city && (
              <span>
                {venue.city.trim()}, {venue.state.trim()} {venue.postalcode.trim()}
              </span>
            )}
            {venue.phone && (
              <>
                <br />
                {venue.phone}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({ data }) => {
  const { meetingInfo, invalidMeetingCode, atCapacity } = data;

  return { meetingInfo, invalidMeetingCode, atCapacity };
};

export default withRouter(
  connect(mapStateToProps, { getMeetingInfo })(AxsomeMeetingInfoComponent)
);
